import { Component, NgZone, OnInit } from '@angular/core';
import { AuthService } from '../../service/main/auth.service';
import { Router } from '@angular/router';
import { CryptoHashService } from '../../service/common/crypto-hash.service';
import Enums from '../../utils/enums';
import { MessageService } from 'primeng/api';
import { HttpErrorResponse } from '@angular/common/http';


@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    providers: [
        MessageService
    ]
})
export class LoginComponent implements OnInit {
    username: string;
    password: string;
    loginRole: number = Enums.eRole.Administrator;
    isLoading: boolean;

    width: any;
    height: any;

    constructor(private authService: AuthService,
        private router: Router,
        private cryptoHash: CryptoHashService,
        private messageService: MessageService
    ) { }

    ngOnInit() {
    }

    login() {
        const user = {
            email: this.username,
            password: this.cryptoHash.sha512(this.password, 512),
            // loginRole: this.getLoginRole(this.loginRole)
        };

        if (!user.email || !user.password) {
            this.messageService.add({ severity: 'error', closable: false, detail: 'Toate campurile sunt obligatorii' });
            return;
        }

        this.isLoading = true;
        this.authService.authenticateUser(user).subscribe(data => {
            this.isLoading = false;
            const authUser = {
                firstName: data.firstName,
                lastName: data.lastName,
                email: data.email,
                createDate: data.createDate,
                phone: data.phone,
                status: data.isActive,
                loginRole: data.loginRole,
                company: this.getUserCompany(data),
                publicInstitution: this.getUserPublicInstitution(data)
            };
            this.authService.storeData(data.token, authUser);

            if (data.loginRole === 'Administrator' || data.loginRole === 'SuperAdministrator') {
                this.router.navigate(['dashboard']);
            } else if (data.loginRole === 'Hotel') {
                this.router.navigate(['vehicle-exceptions']);
            } else if (data.loginRole === 'Police') {
                this.router.navigate(['payments']);
            } else if (data.loginRole === 'EveHandler') {
                this.router.navigate(['eve']);
            }
        }, (ex: HttpErrorResponse) => {
            if (ex.error.message === 'AUTHORIZATION_FAILED') {
                this.messageService.add({ severity: 'error', closable: false, detail: 'A aparut o eroare la logare' });
            } else {
                this.messageService.add({ severity: 'error', closable: false, detail: 'A aparut o eroare la conexiunea cu serverul' });
            }
            this.isLoading = false;
        });
    }

    getUserCompany(data) {
        if (data.company != null) {
            return data.company.companyID;
        } else {
            return null;
        }
    }

    getUserPublicInstitution(data) {
        if (data.publicInstitution) {
            return data.publicInstitution.publicInstitutionID;
        } else {
            return null;
        }
    }

    getLoginRole(role: number): string {
        switch (role) {
            case Enums.eRole.Administrator:
                return 'Administrator';
            case Enums.eRole.Hotel:
                return 'Hotel';
            case Enums.eRole.Police:
                return 'Police';
            case Enums.eRole.SuperAdministrator:
                return 'SuperAdministrator';
        }
    }
}
